<template>
  <div class="notes_datatable">
    <datatable :type="'notes'" :recordType="'order_job'" :rowData="notes" :loadingMessage="loadingMessage" :noRowsMessage="noRowsMessage" :columns="columns"></datatable>
  </div>
</template>

<script>
import datatable from "datatables/datatable";

export default {
  name: "order_notes",
  components: {
    datatable
  },
  props: ['notes', 'notesLoaded'],
  data() {
    return {
      loadingMessage: 'Loading Notes...',
      noRowsMessage: 'No Notes Found',
      columns: [
        {headerName: 'Date', valueGetter: this.date_value_getter},
        {headerName: 'Left By', valueGetter: this.left_by_vg},
        {headerName: 'Type', field: 'note_type.note_type'},
      ]
    }
  },
  methods: {
    date_value_getter(params) {
      return this.$options.filters.formatDateTime(params.data.updated_at);
    },
    left_by_vg(params) {
      return params.data.note_log_by.first_name + ' ' + params.data.note_log_by.surname;
    }
  }
}
</script>

<style scoped lang="scss">
.notes_datatable {
  .full_height_datatable {
    height: calc(100vh - 185px);
  }
}
</style>
